/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyTravelInfo,
    JsonEventPartyTravelInfoFromJSON,
    JsonEventPartyTravelInfoFromJSONTyped,
    JsonEventPartyTravelInfoToJSON,
} from './JsonEventPartyTravelInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyTravelInfo
 */
export interface ApiResultOfJsonEventPartyTravelInfo {
    /**
     * 
     * @type {JsonEventPartyTravelInfo}
     * @memberof ApiResultOfJsonEventPartyTravelInfo
     */
    data?: JsonEventPartyTravelInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravelInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyTravelInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravelInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravelInfo
     */
    result?: ApiResultOfJsonEventPartyTravelInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyTravelInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyTravelInfoFromJSON(json: any): ApiResultOfJsonEventPartyTravelInfo {
    return ApiResultOfJsonEventPartyTravelInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyTravelInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyTravelInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyTravelInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyTravelInfoToJSON(value?: ApiResultOfJsonEventPartyTravelInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyTravelInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

